import {useFetch} from "../useFetch";
import {Counterparty} from "../../types/api/guide/counterparty.types";
import {counterpartyService} from "../../services/guide/counterparty-service";

export const useFetchGetCounterpartyById = (id?: string) => {

    const { isLoading, error, data } =
        useFetch<Counterparty>(
            counterpartyService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as Counterparty, isLoading, error };
}